<template>
  <div class="location-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('simDataRecordExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" @fetch="onPageChange({ page: 1 })" :placeholder="$t('dms_simServiceRecord.qsrjsh')"></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_simServiceRecord.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_simServiceRecord.jfsqdb')">
          <el-input v-model="formSearch.partyAName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_simServiceRecord.yi_fang')">
          <el-input v-model="formSearch.customerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_simServiceRecord.sjksfwrq')">
          <custom-date-picker style="width: 100%" @change="onPageChange({ page: 1 })" v-model="dataTimes" type="daterange" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_simServiceRecord.sjjsfwrq')">
          <custom-date-picker style="width: 100%" @change="onPageChange({ page: 1 })" v-model="dataTimes1" type="daterange" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :tableCode="tableCode" :data="dataList" @filter="filterChange" @sort="sortChange" height="100%" @column="setColumn" index></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'project',
  data() {
    return {
      link: null,
      dataTimes: [],
      dataTimes1: [],
      dataList: [],
      totalRows: 0,
      tableCode: 'simServiceRecord',

      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        customerName: '',
        partyAName: '',
        contractNo: '',
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.formSearch.beginStartDate = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.beginEndDate = this.dataTimes ? this.dataTimes[1] : '';
      this.formSearch.expireStartDate = this.dataTimes1 ? this.dataTimes1[0] : '';
      this.formSearch.expireEndDate = this.dataTimes1 ? this.dataTimes1[1] : '';
      this.$getJSON(apis.simDataRecordPage, this.formSearch).then((res) => {
        this.dataList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    clearFilter() {
      this.dataTimes = [];
      this.dataTimes1 = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss"></style>
